"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUCTION_ACC_DISCRIM = exports.BID_ACC_DISCRIM = exports.UNDERLYING_ACC_DISCRIM = exports.COMBO_OPTION_ACC_DISCRIM = exports.OPTION_ACC_DISCRIM = exports.MINT_OPTION_FEE_DENOMINATOR = exports.MINT_OPTION_FEE_PRECISION = exports.COMBO_SIZE_PRECISION = exports.MAX_COMBO_OPTION_LEGS = exports.COMBO_OPTION_TOKEN_MINT_AMOUNT = exports.OPTION_DECIMAL_ADJUSTMENT = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
exports.OPTION_DECIMAL_ADJUSTMENT = 5;
exports.COMBO_OPTION_TOKEN_MINT_AMOUNT = 10000;
exports.MAX_COMBO_OPTION_LEGS = 10;
exports.COMBO_SIZE_PRECISION = 3;
// Fee is in units of a thousandth of a percent or a tenth of a basis point
exports.MINT_OPTION_FEE_PRECISION = 5;
exports.MINT_OPTION_FEE_DENOMINATOR = Math.pow(10, exports.MINT_OPTION_FEE_PRECISION);
exports.OPTION_ACC_DISCRIM = anchor.BorshAccountsCoder.accountDiscriminator("OptionAccount");
exports.COMBO_OPTION_ACC_DISCRIM = anchor.BorshAccountsCoder.accountDiscriminator("ComboOptionAccount");
exports.UNDERLYING_ACC_DISCRIM = anchor.BorshAccountsCoder.accountDiscriminator("Underlying");
exports.BID_ACC_DISCRIM = anchor.BorshAccountsCoder.accountDiscriminator("BidAccount");
exports.AUCTION_ACC_DISCRIM = anchor.BorshAccountsCoder.accountDiscriminator("AuctionAccount");
